import { useEffect, useMemo, useState } from "react";
import { StyledInvoiceList } from "./invoiceList.styled";
import { InvoiceFilterBar } from "./invoiceListHeader/invoiceListHeader";
import { Invoice } from "../../models/Invoice";
import { InvoiceListItem } from "./InvoiceListItem/invoiceListItem";
import { Box } from "@mui/material";
import { Filters } from "../../models/Filters";
import { useFilteredInvoices } from "../../hooks/useFilteredInvoices";

type InvoiceListProps = {
  invoices: Invoice[];
  fullScreen: boolean;
  onSelect: (invoice: Invoice) => void;
  onFilter?: (filteredInvoices: Invoice[]) => void;
  onRemove?: () => void;
};

export const InvoiceList = ({
  invoices,
  fullScreen,
  onSelect,
  onFilter,
  onRemove
}: InvoiceListProps) => {
  const availableDescriptions = useMemo(() => {
    return Array.from(
      new Set(invoices.map((inv) => inv.description).filter(Boolean))
    );
  }, [invoices]);
  const [filters, setFilters] = useState<Filters>({
    invoiceDate: "",
    paymentDate: "",
    name: "",
    type: "",
    year: "",
    quarters: [],
    projects: [],
    projectsSearch: "",
    descriptions: availableDescriptions,
    selectedDescription: "",
    yearQuarter: [],
    sortDirection: {
      key: "invoiceDate",
      direction: "desc",
    },
  });
  const filteredInvoices = useFilteredInvoices(invoices, filters);

  useEffect(() => {
    onFilter && onFilter(filteredInvoices);
  }, [filters, filteredInvoices])

  const availableYears = useMemo(() => {
    const years = invoices.map((inv) =>
      new Date(inv.invoiceDate).getFullYear().toString()
    );
    return Array.from(new Set(years)).sort();
  }, [invoices]);

  const availableQuarters = useMemo(() => {
    const map: { [year: string]: string[] } = {};
    invoices.forEach((inv) => {
      const year = new Date(inv.invoiceDate).getFullYear().toString();
      if (!map[year]) map[year] = [];
      if (!map[year].includes(inv.quarter)) {
        map[year].push(inv.quarter);
      }
    });
    return map;
  }, [invoices]);

  const Balance: number = useMemo(() => {
    let total = 0;
    if (!filteredInvoices) return 0;

    filteredInvoices.forEach((inv) => {
      if (inv.type === "inkomst" && inv.hasBeenPayed) {
        total += Number(Number(inv.priceExVat) + Number(inv.vat));
      }
      if (inv.type === "uitgave" && inv.hasBeenPayed) {
        total -= Number(Number(inv.priceExVat) + Number(inv.vat));
      }
      if (inv.type === "varia" && inv.hasBeenPayed) {
        total -= Number(Number(inv.priceExVat) + Number(inv.vat));
      }
      if (inv.type === "uitbetaling" && inv.hasBeenPayed) {
        total -= Number(Number(inv.priceExVat) + Number(inv.vat));
      }
    });

    return total;
  }, [filteredInvoices]);

  return (
    <StyledInvoiceList fullScreen={fullScreen}>
      {fullScreen && (
        <InvoiceFilterBar
          filters={filters}
          setFilters={setFilters}
          availableQuarters={availableQuarters}
          availableDescriptions={availableDescriptions}
          availableYears={availableYears}
        />
      )}
      <Box className="list">
        {filteredInvoices.map((invoice) => (
          <InvoiceListItem
            invoice={invoice}
            fullScreen={fullScreen}
            onSelect={onSelect}
            onRemove={onRemove}
          />
        ))}
      </Box>
      Aantal: {filteredInvoices.length}   totaal: {Balance.toFixed(2)}
     
    </StyledInvoiceList>
  );
};
